<div class="waiting-spinner-container">
    <div class="waiting-spinner-container-inside">
        <div class="waiting-spinner-text">
            {{waitingMessage}}
        </div>
        
        <mat-progress-bar class="progress-bar-style" mode="indeterminate"></mat-progress-bar>        
    </div>
</div>